/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Reflex API
 * OpenAPI spec version: 1.0.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  AddTeamMemberBody
} from './model/addTeamMemberBody.js';

import type {
  SetTeamMemberRoleBody
} from './model/setTeamMemberRoleBody.js';

import type {
  UpdateTeamBody
} from './model/updateTeamBody.js';

import { apiFetch } from '../react-mutator.js';



type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

/**
 * @summary Get a team and its members.
 */
export const getTeam = (
    teamId: string,
 options?: SecondParameter<typeof apiFetch>,signal?: AbortSignal
) => {


      return apiFetch<void>(
      {url: `/teams/${encodeURIComponent(String(teamId))}`, method: 'GET', signal
    },
      options);
    }




export const getGetTeamQueryKey = (teamId: string,) => {
    return [
    `/teams/${teamId}`
    ] as const;
    }


export const getGetTeamQueryOptions = <TData = Awaited<ReturnType<typeof getTeam>>, TError = unknown>(teamId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getTeam>>, TError, TData>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTeamQueryKey(teamId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTeam>>> = ({ signal }) => getTeam(teamId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: teamId !== null && teamId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getTeam>>, TError, TData> & { queryKey: QueryKey }
}

export type GetTeamQueryResult = NonNullable<Awaited<ReturnType<typeof getTeam>>>
export type GetTeamQueryError = unknown


/**
 * @summary Get a team and its members.
 */

export function useGetTeam<TData = Awaited<ReturnType<typeof getTeam>>, TError = unknown>(
 teamId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getTeam>>, TError, TData>, request?: SecondParameter<typeof apiFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetTeamQueryOptions(teamId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary Update a team's name, slug, description, or default role.
 */
export const updateTeam = (
    teamId: string,
    updateTeamBody: UpdateTeamBody,
 options?: SecondParameter<typeof apiFetch>,signal?: AbortSignal
) => {


      return apiFetch<void>(
      {url: `/teams/${encodeURIComponent(String(teamId))}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: updateTeamBody, signal
    },
      options);
    }




export const getUpdateTeamMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateTeam>>, TError,{teamId: string;data: UpdateTeamBody}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateTeam>>, TError,{teamId: string;data: UpdateTeamBody}, TContext> => {

const mutationKey = ['updateTeam'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateTeam>>, {teamId: string;data: UpdateTeamBody}> = (props) => {
          const {teamId,data} = props ?? {};

          return  updateTeam(teamId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateTeamMutationResult = NonNullable<Awaited<ReturnType<typeof updateTeam>>>
    export type UpdateTeamMutationBody = UpdateTeamBody
    export type UpdateTeamMutationError = unknown

    /**
 * @summary Update a team's name, slug, description, or default role.
 */
export const useUpdateTeam = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateTeam>>, TError,{teamId: string;data: UpdateTeamBody}, TContext>, request?: SecondParameter<typeof apiFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateTeam>>,
        TError,
        {teamId: string;data: UpdateTeamBody},
        TContext
      > => {
      return useMutation(getUpdateTeamMutationOptions(options));
    }
    /**
 * @summary Permanently delete a team, its memberships, and its team secrets.
 */
export const deleteTeam = (
    teamId: string,
 options?: SecondParameter<typeof apiFetch>,signal?: AbortSignal
) => {


      return apiFetch<void>(
      {url: `/teams/${encodeURIComponent(String(teamId))}`, method: 'DELETE', signal
    },
      options);
    }




export const getDeleteTeamMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteTeam>>, TError,{teamId: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteTeam>>, TError,{teamId: string}, TContext> => {

const mutationKey = ['deleteTeam'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteTeam>>, {teamId: string}> = (props) => {
          const {teamId} = props ?? {};

          return  deleteTeam(teamId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteTeamMutationResult = NonNullable<Awaited<ReturnType<typeof deleteTeam>>>

    export type DeleteTeamMutationError = unknown

    /**
 * @summary Permanently delete a team, its memberships, and its team secrets.
 */
export const useDeleteTeam = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteTeam>>, TError,{teamId: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteTeam>>,
        TError,
        {teamId: string},
        TContext
      > => {
      return useMutation(getDeleteTeamMutationOptions(options));
    }
    /**
 * @summary List the members of a team.
 */
export const listTeamMembers = (
    teamId: string,
 options?: SecondParameter<typeof apiFetch>,signal?: AbortSignal
) => {


      return apiFetch<void>(
      {url: `/teams/${encodeURIComponent(String(teamId))}/members`, method: 'GET', signal
    },
      options);
    }




export const getListTeamMembersQueryKey = (teamId: string,) => {
    return [
    `/teams/${teamId}/members`
    ] as const;
    }


export const getListTeamMembersQueryOptions = <TData = Awaited<ReturnType<typeof listTeamMembers>>, TError = unknown>(teamId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listTeamMembers>>, TError, TData>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListTeamMembersQueryKey(teamId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listTeamMembers>>> = ({ signal }) => listTeamMembers(teamId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: teamId !== null && teamId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listTeamMembers>>, TError, TData> & { queryKey: QueryKey }
}

export type ListTeamMembersQueryResult = NonNullable<Awaited<ReturnType<typeof listTeamMembers>>>
export type ListTeamMembersQueryError = unknown


/**
 * @summary List the members of a team.
 */

export function useListTeamMembers<TData = Awaited<ReturnType<typeof listTeamMembers>>, TError = unknown>(
 teamId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listTeamMembers>>, TError, TData>, request?: SecondParameter<typeof apiFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListTeamMembersQueryOptions(teamId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary Add a user to the team with the team's default role.
 */
export const addTeamMember = (
    teamId: string,
    addTeamMemberBody: AddTeamMemberBody,
 options?: SecondParameter<typeof apiFetch>,signal?: AbortSignal
) => {


      return apiFetch<void>(
      {url: `/teams/${encodeURIComponent(String(teamId))}/members`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: addTeamMemberBody, signal
    },
      options);
    }




export const getAddTeamMemberMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addTeamMember>>, TError,{teamId: string;data: AddTeamMemberBody}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof addTeamMember>>, TError,{teamId: string;data: AddTeamMemberBody}, TContext> => {

const mutationKey = ['addTeamMember'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof addTeamMember>>, {teamId: string;data: AddTeamMemberBody}> = (props) => {
          const {teamId,data} = props ?? {};

          return  addTeamMember(teamId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AddTeamMemberMutationResult = NonNullable<Awaited<ReturnType<typeof addTeamMember>>>
    export type AddTeamMemberMutationBody = AddTeamMemberBody
    export type AddTeamMemberMutationError = unknown

    /**
 * @summary Add a user to the team with the team's default role.
 */
export const useAddTeamMember = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addTeamMember>>, TError,{teamId: string;data: AddTeamMemberBody}, TContext>, request?: SecondParameter<typeof apiFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof addTeamMember>>,
        TError,
        {teamId: string;data: AddTeamMemberBody},
        TContext
      > => {
      return useMutation(getAddTeamMemberMutationOptions(options));
    }
    /**
 * @summary Remove a member from the team.
 */
export const removeTeamMember = (
    teamId: string,
    userId: string,
 options?: SecondParameter<typeof apiFetch>,signal?: AbortSignal
) => {


      return apiFetch<void>(
      {url: `/teams/${encodeURIComponent(String(teamId))}/members/${encodeURIComponent(String(userId))}`, method: 'DELETE', signal
    },
      options);
    }




export const getRemoveTeamMemberMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof removeTeamMember>>, TError,{teamId: string;userId: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof removeTeamMember>>, TError,{teamId: string;userId: string}, TContext> => {

const mutationKey = ['removeTeamMember'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof removeTeamMember>>, {teamId: string;userId: string}> = (props) => {
          const {teamId,userId} = props ?? {};

          return  removeTeamMember(teamId,userId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RemoveTeamMemberMutationResult = NonNullable<Awaited<ReturnType<typeof removeTeamMember>>>

    export type RemoveTeamMemberMutationError = unknown

    /**
 * @summary Remove a member from the team.
 */
export const useRemoveTeamMember = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof removeTeamMember>>, TError,{teamId: string;userId: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof removeTeamMember>>,
        TError,
        {teamId: string;userId: string},
        TContext
      > => {
      return useMutation(getRemoveTeamMemberMutationOptions(options));
    }
    /**
 * @summary Set a team member's role.
 */
export const setTeamMemberRole = (
    teamId: string,
    userId: string,
    setTeamMemberRoleBody: SetTeamMemberRoleBody,
 options?: SecondParameter<typeof apiFetch>,signal?: AbortSignal
) => {


      return apiFetch<void>(
      {url: `/teams/${encodeURIComponent(String(teamId))}/members/${encodeURIComponent(String(userId))}/role`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: setTeamMemberRoleBody, signal
    },
      options);
    }




export const getSetTeamMemberRoleMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setTeamMemberRole>>, TError,{teamId: string;userId: string;data: SetTeamMemberRoleBody}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof setTeamMemberRole>>, TError,{teamId: string;userId: string;data: SetTeamMemberRoleBody}, TContext> => {

const mutationKey = ['setTeamMemberRole'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof setTeamMemberRole>>, {teamId: string;userId: string;data: SetTeamMemberRoleBody}> = (props) => {
          const {teamId,userId,data} = props ?? {};

          return  setTeamMemberRole(teamId,userId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SetTeamMemberRoleMutationResult = NonNullable<Awaited<ReturnType<typeof setTeamMemberRole>>>
    export type SetTeamMemberRoleMutationBody = SetTeamMemberRoleBody
    export type SetTeamMemberRoleMutationError = unknown

    /**
 * @summary Set a team member's role.
 */
export const useSetTeamMemberRole = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setTeamMemberRole>>, TError,{teamId: string;userId: string;data: SetTeamMemberRoleBody}, TContext>, request?: SecondParameter<typeof apiFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof setTeamMemberRole>>,
        TError,
        {teamId: string;userId: string;data: SetTeamMemberRoleBody},
        TContext
      > => {
      return useMutation(getSetTeamMemberRoleMutationOptions(options));
    }
